import poliFoundationRequest from 'src/utils/poliFoundationRequest';

async function scheduleMessage(account, user, data) {
  const response = await poliFoundationRequest.post(
    `/accounts/${account}/users/${user}/scheduled-messages`,
    data
  );
  return response;
}

export default scheduleMessage;
